export class ZoneModel {
  zoneId: number = 0;
  branchId: number = 0;
  code: number = 0;
  name: string = '';
  sellerId: number = 0;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;
}
